module.exports = __webpack_public_path__ + "img/spaghetti-monster-flying.1ee3784f.svg";